import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        {/* Left side – Logo / Brand */}
        <div className="footer-brand">
          <h3>Lutology™</h3>
          <p className="footer-tagline">Topical Luteolin Serum</p>
        </div>

        {/* Center – Navigation */}
        <div className="footer-links">
          <Link to="/terms">Terms of Use</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/shipping-policy">Shipping Policy</Link>
          <Link to="/refund-policy">Refund Policy</Link>
          <Link to="/contact">Contact Us</Link>
        </div>

        {/* Right side – Year */}
        <div className="footer-copy">
          © {new Date().getFullYear()} Lutology. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
